import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchBcaReportData } from "../../../redux/hygiene-reducers/hygieneSlice";
import "../../../styles/trainer-member/bca-report.css";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import BCAUpload from "./BCAUpload";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { isDev } from "../../common-data/Commons";
import BCAReportLogsMobile from "./BCAReportLogsMobile";
import TableSkeleton from "../../common-components/TableSkeleton";
import { CrossCircleIcon } from "../../../images/icons/icons";

const BCAReport = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { bcaReportLoading, bcaReport } = useSelector((state) => state.hygiene);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isTrainer = userInfoData?.account_type === "trainer";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedTrainer: isTrainer
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.user_id || userInfoData?.uid || "",
        }
      : "",
    isActive: "",
    selectedTrainerStatus: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: rowData?.user_id || "",
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    trainer_status: allFilters.selectedTrainerStatus?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniDatas = {
    pagination: [],
    bcaReport: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getBcaReportData(filters) {
    if (filters.user_id) {
      dispatch(
        fetchBcaReportData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      trainer_status: allFilters.selectedTrainerStatus?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [isPage, pageLimit, allFilters]);

  useEffect(() => {
    getBcaReportData(filters);
  }, [filters, rowData?.user_id]);

  useEffect(() => {
    if (
      !bcaReportLoading &&
      // !bcaReportError &&
      bcaReport?.status &&
      bcaReport?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        bcaReport: bcaReport.data,
        pagination: bcaReport?.pagination || [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    bcaReportLoading,
    // bcaReportError,
    bcaReport,
    rowData?.user_id,
  ]);

  const tbColumns = [
    {
      dataField: "trainer_id",
      text: "Trainer Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.trainer_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "trainer_status",
      text: "trainer Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth60 withPadding borderRdius8"
            style={{
              background: !row?.trainer_status
                ? ""
                : row?.trainer_status === "active"
                ? "#379C00"
                : row?.trainer_status === "pending"
                ? "#157EF9"
                : "#C80000",
              color: !row?.trainer_status ? "#000" : "#fff",
            }}
          >
            {row?.trainer_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "BCA Status",
      formatter: (_, row) => {
        const isCompleted = row?.status === "completed";
        const isPending =
          (row?.status === "pending" && isTrainer) ||
          (row?.status === "pending" && isDev);

        return (
          <span
            className={`tb-data minWidth100 ${
              isCompleted || isPending ? "icon" : "withPadding borderRdius8"
            }`}
            style={{
              background:
                isCompleted || isPending
                  ? ""
                  : row?.status === "completed"
                  ? "#379C00"
                  : row?.status === "upcoming"
                  ? "#157EF9"
                  : row?.status === "pending"
                  ? "#FB9E3A"
                  : "#C80000",
              color: isCompleted || isPending ? "" : "#fff",
              cursor: isPending ? "pointer" : "not-allowed",
            }}
          >
            {isCompleted ? (
              <>
                {row?.bca_report ? (
                  <a
                    className=""
                    rel="noreferrer"
                    target="_blank"
                    href={row.bca_report}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-box-arrow-up-right"
                      viewBox="0 0 16 16"
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                      }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                      />
                      <path
                        fillRule="evenodd"
                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                      />
                    </svg>
                  </a>
                ) : (
                  <CrossCircleIcon />
                )}
              </>
            ) : isPending ? (
              <>
                <button
                  className="btn btn-outline-dark"
                  disabled={!isPending}
                  style={{
                    textTransform: "capitalize",
                    minWidth: "100px",
                  }}
                  onClick={() =>
                    isPending &&
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: row,
                      modName: "upload_bca",
                    }))
                  }
                >
                  click to upload
                </button>
              </>
            ) : (
              row?.status?.replace(/_/g, " ") || "NA"
            )}
          </span>
        );
      },
    },
    {
      dataField: "scheduled_date",
      text: "Scheduled Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.scheduled_date ? convertStraight(row.scheduled_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "completed_on",
      text: "Completed On",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.completed_on ? convertStraight(row.completed_on) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          {modValues.modName !== "upload_bca" && (
            <ModalHeadAndClose
              title={modValues.modName?.replace(/_/g, " ")}
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "upload_bca" ? (
            <BCAUpload
              isEdit={modValues.modName === "edit"}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={() => getBcaReportData(filters)}
            />
          ) : null}
        </div>
      </Modal>

      <CmnFilters
        from="bca-report"
        userInfoData={userInfoData}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onResetFilters}
        isLoading={bcaReportLoading}
      />

      {bcaReportLoading ? (
        <TableSkeleton
          columns={tbColumns?.length || 10}
          rows={pageLimit || 10}
        />
      ) : (
        <>
          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30 hideMobile">
            <PaymentLinkTable
              tableData={allDatas.bcaReport}
              tableColumns={tbColumns}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>

          <div className="lead-logs-card-container only-mobile">
            <BCAReportLogsMobile
              tableData={allDatas.bcaReport}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              loading={bcaReportLoading}
              setModValues={setModValues}
              userInfoData={userInfoData}
            />
          </div>
        </>
      )}
    </>
  );
};

export default BCAReport;
